"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productGroupSchema = void 0;
const zod_1 = require("zod");
// Full DB row schema — mirrors Prisma ProductGroup model exactly.
// nameTr has a UNIQUE constraint; nameEn defaults to "".
exports.productGroupSchema = zod_1.z.object({
    id: zod_1.z.string(),
    nameTr: zod_1.z.string(),
    nameEn: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
//# sourceMappingURL=product-group.js.map